<app-modal-basic #modalRelatorio [modalContentId]="'modal-vendaporclientecidade'" (closed)="onClose()">
    <div class="app-modal-header">
        <h4 class="modal-title">
            <i class="ti ti-file-text"></i> Relatório Vendas por Cliente/Cidade
            <button type="button" class="close basic-close" (click)="modalRelatorio.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </h4>
    </div>
    <div class="app-modal-body">
        <form [formGroup]="impressaoForm" (ngSubmit)="submitForm()">
            <div class="row">
                <div class="form-group col-sm-12">
                    <label> Estado </label>
                    <div class='input'>
                        <ng-select appendTo="#modal-vendaporclientecidade" formControlName="estadoId" *ngIf="estadosMap"
                        placeholder="Estado" [items]="estadosMap" bindLabel="nome" bindValue="id"
                        (ngModelChange)="onChangeEstado($event)" [disableControl]="loading['disable'] || loading['request']">
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-12">
                    <label> Cidade </label>
                    <div class='input'>
                        <ng-select appendTo="#modal-vendaporclientecidade" formControlName="cidadeId" *ngIf="cidadesMap"
                        placeholder="Cidade" [items]="cidadesMap" bindLabel="nome" bindValue="id" [disableControl]="loading['disable'] || loading['request']">
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-12">
                <label>Compras de</label>
                <div class="input-group">
                    <app-data [calendarPosition]="'left'" formControlName="dataInicial"></app-data>
                    <span class="input-group-addon">até</span>
                    <app-data [loading]="loading['buscandoData']" formControlName="dataFinal"></app-data>
                </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <show-errors [control]="impressaoForm.controls.dataInicial"></show-errors>
                        </div>
                        <div class="col-sm-6">
                            <show-errors [control]="impressaoForm.controls.dataFinal"></show-errors>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-sm-12">
                    <label>Clientes</label>
                    <div class="input">
                        <ng-select
                            appendTo="#modal-vendaporclientecidade"
                            formControlName="clientes"
                            [items]="statusOptions"
                            bindLabel="label"
                            bindValue="value"
                            placeholder="Selecione o status"
                            [disableControl]="loading['disable'] || loading['request']">
                        </ng-select>
                    </div>
                </div>
            </div>
            <div class="row form-group col-sm-12">
                <div class="form-radio form-control" style="border: unset; padding-left: 0px;">
                    <div class="radio radio-inline">
                        <label style="margin-bottom: 0px;">
                        <input type="radio" formControlName="tipo" value="C"
                            [disableControl]="loading['disable'] || loading['request']">
                        <i class="helper"></i><span> Completo</span>
                        </label>
                    </div>
                    <div class="radio radio-inline">
                        <label style="margin-bottom: 0px;">
                        <input type="radio" formControlName="tipo" value="R"
                            [disableControl]="loading['disable'] || loading['request']">
                        <i class="helper"></i><span> Reduzido</span>
                        </label>
                    </div>
                </div>
            </div>
            <button type="submit" (click)="validaForm()" class="btn btn-primary ripple light" [disabled]="loading['imprimindo']">
                <app-loading [loading]="loading['imprimindo']" icone="icofont icofont-print" texto="Imprimir" textoLoading="Imprimindo..."/>
            </button>
            <button type="button" class="btn btn-danger ripple" (click)="modalRelatorio.hide()"><i class="ti ti-close"></i>
                Cancelar
            </button>
        </form>
    </div>
    <div class="app-modal-footer"></div>
</app-modal-basic>